import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { RentalWithRelations } from "@/types/models";
import { format, parseISO } from "date-fns";

interface TodayRentalHistoryCardsProps {
  rentals: RentalWithRelations[];
}

const TodayRentalHistoryCards = ({ rentals }: TodayRentalHistoryCardsProps) => {
  if (!rentals || rentals.length === 0) {
    return (
      <div>
        <h3 className="text-2xl font-semibold leading-none tracking-tight mb-3">Historial de Alquileres de Hoy</h3>
        <p className="text-sm text-gray-500">No hay alquileres completados hoy.</p>
      </div>
    );
  }

  return (
    <div>
      <Card>
        <CardHeader>
          <CardTitle>Alquileres Recientes</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4 max-h-[350px] overflow-y-auto">
            {rentals.map((rental) => (
              <div key={rental.id} className="flex items-center justify-between border-b pb-2">
                <div>
                  <p className="font-medium">{rental.customer?.name || "N/A"} <span className="text-muted-foreground text-sm">({rental.branch?.name || "N/A"})</span></p>
                  <p className="text-sm text-muted-foreground">
                    {rental.bike ? `${rental.bike.model} #${rental.bike.number}` : "N/A"}
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-sm">
                    {rental.start_date ? format(parseISO(rental.start_date), "hh:mm a") : "N/A"} -{" "}
                    {rental.end_date ? format(parseISO(rental.end_date), "hh:mm a") : "N/A"}
                  </p>
                  <p className="text-xs font-medium text-bike-500">
                    {rental.total_amount != null ? `$${rental.total_amount.toFixed(2)}` : "N/A"}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default TodayRentalHistoryCards;
